import {
  ClassServiceDefinitionResponse,
  ClassServicesDefinitionEntry,
} from '../../api/v2';
import { ServiceType } from './serviceTypes.interfaces';

export const serviceTypeToClassServiceDefinitionEntry = (
  serviceType: ServiceType,
): ClassServicesDefinitionEntry => {
  return {
    isDisabled: !serviceType.isActive,
    description: serviceType.description,
    fullName: serviceType.fullName,
    shortName: serviceType.shortName,
  };
};

export const classServiceDefinitionEntryToServiceType = (
  serviceTypeDefinition: ClassServicesDefinitionEntry,
): ServiceType => {
  return {
    isActive: !serviceTypeDefinition.isDisabled,
    description: serviceTypeDefinition.description ?? '',
    shortName: serviceTypeDefinition.shortName ?? '',
    fullName: serviceTypeDefinition.fullName ?? '',
  };
};

export const serviceTypeToClassServiceDefinitionResponse = (
  serviceType: ServiceType,
): ClassServiceDefinitionResponse => {
  return {
    description: serviceType.description,
    fullName: serviceType.fullName,
    shortName: serviceType.shortName,
    id: serviceType.id ?? '',
    isDisabled: !serviceType.isActive,
  };
};

export const classServicesDefinitionResponseToServiceType = (
  serviceResponse: ClassServiceDefinitionResponse,
): ServiceType => {
  return {
    description: serviceResponse.description ?? '',
    fullName: serviceResponse.fullName ?? '',
    isActive: !serviceResponse.isDisabled,
    shortName: serviceResponse.shortName ?? '',
    id: serviceResponse.id,
  };
};

export const classServiceDefinitionResponseToServiceType = (
  definitionResponse: ClassServiceDefinitionResponse,
): ServiceType => {
  return {
    description: definitionResponse.description ?? '',
    fullName: definitionResponse.fullName ?? '',
    isActive: !definitionResponse.isDisabled,
    shortName: definitionResponse.shortName ?? '',
    id: definitionResponse.id,
  };
};
